module.exports = __webpack_public_path__ + "static/media/asset_3.64a2d85e.png";